<template>
    <div>
        <UserDrafts />
    </div>
</template>

<script>
    import UserDrafts from '../Core/RecordComponents/UserDrafts.vue';

    export default {
        name: "EmbedUserDrafts",
        props: [

        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
            UserDrafts
        },
        computed: {
        },
    }
</script>